import { appComponentsStorage } from '@frameio/shared/storage';

const STORAGE_KEY = 'frame-io--last-viewed-whats-new';

export const readLastViewedTimeFromLocalStorage = () => {
  try {
    const timestamp = appComponentsStorage.get(STORAGE_KEY);

    return timestamp ?? 0;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error reading from localStorage', error);
    return 0;
  }
};

// Save last opened timestamp to localStorage
export const saveLastViewedTimestampToLocalStorage = (time: number) => {
  try {
    appComponentsStorage.set(STORAGE_KEY, time);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('Error saving to localStorage', err);
  }
};
